import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterFacet,
  SortOption,
  SparePartCondition,
  STOCK_ITEM_STATUS,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.sparePart}search/filteredStockItemGroups`;

export interface StockItemSearchSummary {
  stockItemId: string;
  stockItemStatus: STOCK_ITEM_STATUS;
  sparePartReference?: string;
  stockName?: string;
  fileReference?: string;
  supplierName?: string;
  supplierPartReference?: string;
  stockInputTimeUtc: string;
  location?: string;
  sellingPrice: number;
  purchasePrice: number;
  currency?: string;
  condition: SparePartCondition;
  manufacturerName?: string;
  manufacturerLabel?: string;
}

export interface StockItemGroupSearchSummary {
  stockItems?: StockItemSearchSummary[];
  stockItemIds?: string[];
  sparePartReference?: string;
  stockName?: string;
  supplierName?: string;
  supplierPartReference?: string;
  manufacturerName?: string;
  manufacturerLabel?: string;
  lastStockInputTimeUtc?: string;
  sellingPriceSum: number;
  purchasePriceSum: number;
  currency?: string;
  quantity: number;
  availableQuantity: number;
}

export interface ListStockItemGroupsOnStockCommandArgs {
  query?: string;
  pageSize?: number;
  page?: number;
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
  sortOptions?: SortOption[];
  sellerId?: string;
  tenantId?: string;
}

async function listStockItemGroupsOnStockCommand({
  query,
  page,
  pageSize,
  sort,
  isDescending,
  filters,
  groupedFilters,
  dateTimeFilters,
  queryableFilters,
  sortOptions,
  sellerId,
  tenantId,
}: ListStockItemGroupsOnStockCommandArgs): Promise<
  | BackResponse<SearchResultList<StockItemGroupSearchSummary>>
  | BackResponseFailure
> {
  try {
    return await apiCall<
      BackResponse<SearchResultList<StockItemGroupSearchSummary>>
    >(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        page,
        pageSize,
        sort,
        isDescending,
        filters,
        groupedFilters,
        dateTimeFilters,
        queryableFilters,
        sortOptions,
        sellerId,
        tenantId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default listStockItemGroupsOnStockCommand;
